// Mock data for AMAIA.CLOUD Hire Worker

// Cartoon avatars from DiceBear notionists (deterministic, unique per worker)
const AV = (seed, bg = 'transparent') =>
  `https://api.dicebear.com/9.x/notionists/svg?seed=${encodeURIComponent(seed)}&backgroundColor=${bg}&radius=50`;

export const INTEGRATION_ICONS = {
  notion: 'https://app.delos.so/images/integrations/notion.svg?dpl=v5-1-25',
  canva: 'https://app.delos.so/assets/icons/canva.svg?dpl=v5-1-25',
  instagram: 'https://app.delos.so/images/integrations/instagram.svg?dpl=v5-1-25',
  linkedin: 'https://app.delos.so/images/integrations/linkedin.svg?dpl=v5-1-25',
  x: 'https://cdn-icons-png.flaticon.com/512/5969/5969020.png',
  apollo: 'https://app.delos.so/assets/icons/apollo.svg?dpl=v5-1-25',
  lemlist: 'https://app.delos.so/assets/icons/lemlist.svg?dpl=v5-1-25',
  hubspot: 'https://app.delos.so/assets/icons/hubspot.svg?dpl=v5-1-25',
  teams: 'https://app.delos.so/assets/icons/teams.png?dpl=v5-1-25',
  posthog: 'https://app.delos.so/assets/icons/posthog.svg?dpl=v5-1-25',
  github: 'https://app.delos.so/assets/icons/github.svg?dpl=v5-1-25',
  sharepoint: 'https://app.delos.so/assets/icons/sharepoint.svg?dpl=v5-1-25',
  salesforce: 'https://app.delos.so/assets/icons/salesforce.svg?dpl=v5-1-25',
  box: 'https://app.delos.so/assets/icons/box.svg?dpl=v5-1-25',
  pappers: 'https://app.delos.so/assets/icons/pappers.svg?dpl=v5-1-25',
  atlassian: 'https://app.delos.so/assets/icons/atlassian.svg?dpl=v5-1-25',
  grafana: 'https://app.delos.so/assets/icons/grafana.svg?dpl=v5-1-25',
  excalidraw: 'https://app.delos.so/assets/icons/excalidraw.svg?dpl=v5-1-25',
  linear: 'https://app.delos.so/assets/icons/linear.svg?dpl=v5-1-25',
  qonto: 'https://app.delos.so/assets/icons/qonto.svg?dpl=v5-1-25',
  pennylane: 'https://app.delos.so/assets/icons/pennylane.svg?dpl=v5-1-25',
  stripe: 'https://app.delos.so/assets/icons/stripe.svg?dpl=v5-1-25',
};

export const CATEGORIES = [
  { key: 'all', label: 'All' },
  { key: 'assistant', label: 'Assistant' },
  { key: 'sales', label: 'Sales' },
  { key: 'support', label: 'Support' },
  { key: 'marketing', label: 'Marketing' },
  { key: 'tech', label: 'Tech' },
  { key: 'finance', label: 'Finance' },
  { key: 'legal', label: 'Legal' },
  { key: 'leadership', label: 'Leadership' },
];

export const WORKERS = [
  { id: 'karen', name: 'Karen', role: 'Content Creator', category: ['marketing'],
    description: 'Produces engaging written, visual, and social content at scale — keeping your brand voice consistent and your audience growing every week.',
    capabilities: ['Produce multi-format content', 'Manage social media'],
    tools: ['notion', 'canva', 'instagram', 'linkedin', 'x'], extra: 1,
    tags: ['Content', 'Social Media', 'Copywriting'],
    avatarColor: 'from-rose-100 to-orange-100', initial: 'K',
    avatar: AV('karen-content-creator', 'ffd6b3') },
  { id: 'sophie', name: 'Sophie', role: 'Sales Prospector', category: ['sales'],
    description: 'Identifies and qualifies new leads, enriches your CRM with prospect data, and books meetings — so your sales team only talks to warm leads.',
    capabilities: ['Identify and qualify accounts and leads', 'Feed the CRM and structure qualification', 'Run multichannel prospecting'],
    tools: ['apollo', 'lemlist', 'hubspot', 'linkedin', 'teams'], extra: 4,
    tags: ['Sales', 'Prospecting', 'CRM'],
    avatarColor: 'from-emerald-100 to-teal-100', initial: 'S',
    avatar: AV('sophie-sales-prospector', 'b6e3f4') },
  { id: 'nova', name: 'Nova', role: 'Webmaster & SEO', category: ['marketing', 'tech'],
    description: 'Maintains your site, monitors technical SEO, improves Core Web Vitals, and coordinates content updates with marketing.',
    capabilities: ['Audit and fix technical SEO', 'Own Core Web Vitals and web performance', 'Coordinate content go-lives and CMS changes'],
    tools: ['notion', 'posthog', 'teams', 'linkedin', 'github'],
    tags: ['SEO', 'CMS', 'Performance'],
    avatarColor: 'from-violet-100 to-fuchsia-100', initial: 'N',
    avatar: AV('nova-webmaster-seo', 'c9b6f4') },
  { id: 'james', name: 'James', role: 'General Assistant', category: ['assistant'],
    description: 'Creates documents and presentations, schedules meetings, preps materials, and handles admin tasks — your always-on executive assistant.',
    capabilities: ['Create documents and presentations', 'Run calendars and scheduling', 'Prep meetings and light logistics'],
    tools: ['notion', 'teams', 'sharepoint'],
    tags: ['Operations', 'Documents', 'Scheduling'],
    avatarColor: 'from-sky-100 to-blue-100', initial: 'J',
    avatar: AV('james-general-assistant', 'a7d8ff') },
  { id: 'belle', name: 'Belle Ringwell', role: 'Receptionist', category: ['support', 'assistant'],
    description: 'Welcomes visitors, handles calls and emails, routes requests, and manages appointments and meeting rooms — your front desk, always on.',
    capabilities: ['Welcome and route visitors and callers', 'Run the switchboard and inbox', 'Schedule appointments and meeting rooms'],
    tools: ['notion', 'teams', 'salesforce', 'hubspot'], extra: 7,
    tags: ['Front Desk', 'Calls', 'Scheduling'],
    avatarColor: 'from-amber-100 to-yellow-100', initial: 'B',
    avatar: AV('belle-receptionist', 'ffe0a3') },
  { id: 'ivan', name: 'Ivan', role: 'Legal Assistant', category: ['legal'],
    description: 'Reviews contracts, flags legal risks, drafts standard agreements, and monitors regulatory changes — so your team stays protected and compliant.',
    capabilities: ['Support contract review', 'Facilitate documentation and compliance', 'Monitor regulatory updates'],
    tools: ['notion', 'teams', 'sharepoint', 'box', 'pappers'],
    tags: ['Legal', 'Contracts', 'Compliance'],
    avatarColor: 'from-stone-100 to-neutral-200', initial: 'I',
    avatar: AV('ivan-legal-assistant', 'd4d4d4') },
  { id: 'laura', name: 'Laura', role: 'Sales Assistant', category: ['sales'],
    description: 'Keeps your CRM up to date, tracks pipeline health, and delivers weekly reports — so your sales team stays focused on closing.',
    capabilities: ['Keep CRM and pipeline data accurate', 'Produce sales reporting', 'Coordinate deal progress'],
    tools: ['hubspot', 'salesforce', 'notion', 'teams', 'linkedin'], extra: 6,
    tags: ['Sales', 'CRM', 'Pipeline'],
    avatarColor: 'from-pink-100 to-rose-100', initial: 'L',
    avatar: AV('laura-sales-assistant', 'ffc6d0') },
  { id: 'atif', name: 'Atif', role: 'IT Support', category: ['support', 'tech'],
    description: 'Handles IT tickets, troubleshoots issues, manages access rights, and keeps your infrastructure running smoothly — 24/7.',
    capabilities: ['Answer support tickets', 'Maintain FAQ and Help Center'],
    tools: ['notion', 'atlassian', 'teams', 'github', 'github'], extra: 2,
    tags: ['IT', 'Helpdesk', 'Monitoring'],
    avatarColor: 'from-indigo-100 to-blue-100', initial: 'A',
    avatar: AV('atif-it-support', 'b3c7ff') },
  { id: 'victoria', name: 'Victoria Pitch', role: 'VC Assistant', category: ['finance', 'assistant'],
    description: 'Always curious, quick-witted, and never afraid to challenge assumptions—Victoria thrives on uncovering hidden opportunities and connecting the dots before anyone else.',
    capabilities: ['Market Sourcing & Mapping', 'Deal Pipeline Management', 'Founder Outreach & Engagement', 'Meeting Coordination & Prep'],
    tools: ['linkedin', 'apollo', 'teams', 'sharepoint', 'atlassian'], extra: 1,
    tags: [],
    avatarColor: 'from-purple-100 to-violet-100', initial: 'V',
    avatar: AV('victoria-vc-assistant', 'd7c4ff') },
  { id: 'henry', name: 'Henry', role: 'Data Analyst', category: ['tech'],
    description: 'Turns raw data into clear dashboards, trend reports, and business insights — helping your team make faster, better-informed decisions.',
    capabilities: ['Produce reports and dashboards', 'Identify trends and anomalies'],
    tools: ['notion', 'github', 'posthog', 'teams', 'stripe'], extra: 2,
    tags: ['Data', 'Analytics', 'Reporting'],
    avatarColor: 'from-cyan-100 to-sky-100', initial: 'H',
    avatar: AV('henry-data-analyst', 'a3e3ff') },
  { id: 'camille', name: 'Camille', role: 'Bid Manager', category: ['sales'],
    description: 'Receives incoming tenders, qualifies whether the company should respond, mobilizes the right internal experts, and keeps the bid dashboard current from intake to outcome.',
    capabilities: ['Centralize and qualify incoming tenders', 'Produce an evidence-based go / no-go recommendation', 'Identify the right internal stakeholders and experts', 'Maintain the tender dashboard and feedback loop'],
    tools: ['notion', 'teams', 'sharepoint', 'box', 'atlassian'],
    tags: ['Tender', 'Bid Management', 'Qualification'],
    avatarColor: 'from-lime-100 to-green-100', initial: 'C',
    avatar: AV('camille-bid-manager', 'c9f2b4') },
  { id: 'sun', name: 'Sun', role: 'AI Engineer', category: ['tech'],
    description: 'Designs, codes and ships software on your real repositories — reads your codebase and conventions, then delivers fixes and features as clean pull requests.',
    capabilities: ['Master the codebase', 'Ship fixes and features', 'Design and harden AI systems'],
    tools: ['notion', 'github', 'posthog', 'teams', 'github'], extra: 3,
    tags: ['AI', 'Automation', 'Engineering'],
    avatarColor: 'from-orange-100 to-amber-100', initial: 'S',
    avatar: AV('sun-ai-engineer', 'ffcc99') },
  { id: 'arjun', name: 'Arjun', role: 'IT Systems & Security Support', category: ['tech', 'support'],
    description: 'Monitors infrastructure, handles system incidents, manages access rights, and strengthens cybersecurity — keeping your IT estate robust, auditable, and resilient.',
    capabilities: ['Monitor infrastructure and handle system incidents', 'Manage identities, access, and permissions', 'Strengthen the security posture'],
    tools: ['notion', 'github', 'github', 'grafana', 'posthog'], extra: 5,
    tags: ['IT', 'Security', 'Infrastructure'],
    avatarColor: 'from-slate-100 to-gray-200', initial: 'A',
    avatar: AV('arjun-it-security', 'cbd5e1') },
  { id: 'alex', name: 'Alex', role: 'Marketing Manager', category: ['marketing'],
    description: 'Plans and executes multi-channel marketing campaigns, tracks performance, and grows your brand awareness — data-driven and audience-first.',
    capabilities: ['Plan and execute campaigns', 'Analyze marketing performance'],
    tools: ['hubspot', 'notion', 'linkedin', 'instagram', 'x'], extra: 7,
    tags: ['Marketing', 'Campaigns', 'Growth'],
    avatarColor: 'from-teal-100 to-emerald-100', initial: 'A',
    avatar: AV('alex-marketing-manager', 'a3e6d0') },
  { id: 'alexa', name: 'Alexa', role: 'Designer', category: ['marketing'],
    description: 'Crafts visual identities, UI components, and marketing assets that align with your brand — from wireframe to pixel-perfect delivery.',
    capabilities: ['Create visual assets', 'Maintain visual consistency'],
    tools: ['notion', 'excalidraw', 'canva', 'linear', 'box'], extra: 2,
    tags: ['Design', 'UI/UX', 'Branding'],
    avatarColor: 'from-fuchsia-100 to-pink-100', initial: 'A',
    avatar: AV('alexa-designer', 'ffb3e6') },
  { id: 'jeanne', name: 'Jeanne', role: 'Accountant', category: ['finance'],
    description: 'Collects invoices and expense claims from teammates, reconciles them against bank transactions, and delivers weekly finance recommendations with missing-document alerts.',
    capabilities: ['Collect invoices and receipts from teammates', 'Reconcile bank transactions with supporting documents', 'Run the weekly finance report and debrief', 'Review expense claims and recommend reimbursement decisions'],
    tools: ['qonto', 'notion', 'teams', 'pennylane', 'stripe'], extra: 1,
    tags: ['Finance', 'Reconciliation', 'Reporting'],
    avatarColor: 'from-yellow-100 to-amber-100', initial: 'J',
    avatar: AV('jeanne-accountant', 'fff3a3') },
  { id: 'rosa', name: 'Rosa', role: 'Tender Response Manager', category: ['sales'],
    description: 'Monitors tenders, qualifies opportunities, and prepares the complete response package from the consultation rules and your internal documentation.',
    capabilities: ['Monitor and qualify tenders', 'Prepare response dossiers'],
    tools: ['sharepoint', 'notion'],
    tags: ['Tenders', 'Public Procurement', 'Compliance'],
    avatarColor: 'from-red-100 to-rose-100', initial: 'R',
    avatar: AV('rosa-tender-manager', 'ffc0c0') },
  { id: 'matteo', name: 'Matteo', role: 'Senior Full-Stack Engineer', category: ['tech'],
    description: 'Senior full-stack developer: codes front and back end to end, ships clean, tested pull requests, and keeps CI/CD, infrastructure and observability healthy.',
    capabilities: ['Master the codebase & delivery chain', 'Ship full-stack features', 'Harden & industrialize', 'Design polished interfaces'],
    tools: ['github', 'github', 'notion', 'linear', 'stripe'], extra: 1,
    tags: [],
    avatarColor: 'from-blue-100 to-indigo-100', initial: 'M',
    avatar: AV('matteo-fullstack', 'b3d1ff') },
  { id: 'morgan', name: 'Morgan', role: 'Financial Analyst', category: ['finance'],
    description: 'Delivers data-driven financial insights, forecasting, and reporting to support strategic decision-making and optimize business performance.',
    capabilities: ['Build Financial Models', 'Generate Performance Reports', 'Analyze Budget Variances', 'Monitor Key Financial Metrics'],
    tools: ['hubspot'],
    tags: [],
    avatarColor: 'from-green-100 to-emerald-100', initial: 'M',
    avatar: AV('morgan-financial-analyst', 'b8ecc0') },
  { id: 'lucia', name: 'Lucia Newstori', role: 'Journalist Assistant', category: ['marketing'],
    description: 'Monitors the news, spots the stories that matter, writes articles, briefs and summaries, and fact-checks before publishing — your newsroom always on watch.',
    capabilities: ['News monitoring & topic detection', 'Write articles, briefs and summaries', 'Fact-checking', 'Conduct phone interviews'],
    tools: ['x'],
    tags: ['News', 'Press', 'Editorial'],
    avatarColor: 'from-orange-100 to-red-100', initial: 'L',
    avatar: AV('lucia-journalist', 'ffb894') },
  { id: 'mickael', name: 'Mickael', role: 'Consultant', category: ['leadership'],
    description: 'Diagnoses operational bottlenecks, designs improvement plans, and drives strategic projects — bringing an outside perspective with inside commitment.',
    capabilities: ['Diagnose and optimize processes', 'Drive strategic projects'],
    tools: ['notion', 'linkedin', 'teams', 'salesforce', 'hubspot'], extra: 4,
    tags: ['Strategy', 'Operations', 'Consulting'],
    avatarColor: 'from-neutral-100 to-stone-200', initial: 'M',
    avatar: AV('mickael-consultant', 'e5e5e5'), comingSoon: true },
  { id: 'thierry', name: 'Thierry', role: 'Scientific Researcher & Advisor', category: ['tech'],
    description: 'Runs scientific monitoring, synthesizes the literature, vets sources, and produces well-argued, sourced recommendation notes.',
    capabilities: ['Scientific monitoring and literature review', 'Reasoned recommendation notes'],
    tools: ['notion', 'sharepoint'],
    tags: ['Scientific Research', 'Monitoring', 'Literature Review'],
    avatarColor: 'from-emerald-100 to-green-100', initial: 'T',
    avatar: AV('thierry-scientist', 'c1e8d0'), comingSoon: true },
];

export const getCategoryCount = (key) => {
  if (key === 'all') return WORKERS.length;
  return WORKERS.filter((w) => w.category.includes(key)).length;
};

export const getWorkerById = (id) => WORKERS.find((w) => w.id === id);
